// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#d5d5d5","menuBgClose":"#d5d5d5","menuText":"#171819","menuActiveText":"#171819","theme":"#1890ff"};